/* eslint-disable no-param-reassign */

export default {
  getMarketRateSettings(state){
    return state.referenceMarketRate
  }
};
